import React, { useEffect, useRef, useState } from 'react';
import { useInView } from 'react-intersection-observer';
import CountUp from 'react-countup';
import '../css/main.css';
import '../css/homeAnimations.css';
import ourLooking from '../assest/home/376aa6d07e87a77097643bcf2ba576d820b686b6.png';
import ourMessage from '../assest/home/34db76f26b014c233f390591be40be86188a795b.png';
import ourValues from '../assest/home/2b96e33db462d8a07e237d68a08deb1723e1d5dd.png';
import { Outlet, useLocation, Link } from 'react-router-dom';
import Header from '../components/layout/header';
import yearOfExp from '../assest/footer/9889a6af2e15b9cd7fa0cf51f36c75993e41f7fa (1).png'
import infoComCre from '../assest/home/moreInfo/6d9a7a2b16a6846f2c44b0b1177ca6ca21e8c73a.png'
import CustomerSatisfaction from '../assest/home/moreInfo/1c065f0347786d54a0ebbe6b9ff94dc43a4c2279.png'
import ImployeeInSer from '../assest/home/moreInfo/23b924f2850a017ef90f1c8c38036686ad3dbee3.png'

const data = {
    year: 14,
    companyCreated: 6125,
    customerSatisfaction: 100,
    employees: 41
}

// مكون CountUp آمن مع Error Boundary
const SafeCountUp = ({ end, suffix = '', duration = 5 }) => {
    const [isVisible, setIsVisible] = useState(false);
    const [key, setKey] = useState(0);

    useEffect(() => {
        // تأخير بسيط لضمان mount المكون
        const timer = setTimeout(() => {
            setIsVisible(true);
            setKey(prev => prev + 1);
        }, 100);

        return () => clearTimeout(timer);
    }, []);

    if (!isVisible) {
        return <span>0{suffix}</span>;
    }

    return (
        <CountUp
            key={key}
            end={end}
            duration={duration}
            suffix={suffix}
        />
    );
};

function Home() {
    const [ref, inView] = useInView({
        triggerOnce: true,
        threshold: 0.5,
    });

    const location = useLocation();
    const [isScrolling, setIsScrolling] = useState(false);

    useEffect(() => {
        // منع التلاعب المباشر بالDOM - استخدام state بدلاً من ذلك
        if (location.pathname === '/home/all' ||
            location.pathname === '/about' ||
            location.pathname === '/about/contactus') {

            setIsScrolling(true);

            const timer = setTimeout(() => {
                setIsScrolling(false);
            }, 1000);

            return () => clearTimeout(timer);
        }
    }, [location.pathname]);

    const Active = {
        allServices: location.pathname == '/home' || location.pathname == '/home/all',
        companyCreated: location.pathname === "/home/companycreated",
        supportServices: location.pathname === "/home/supportservices",
        premiumResidency: location.pathname === "/home/premiumresidency",
        marketingServices: location.pathname === "/home/marketingservices",
        accountingServices: location.pathname === "/home/accountingservices",
        programming: location.pathname.endsWith('/programming'),
        intellectualProperty: location.pathname.endsWith('/intellpropservices')
    };

    const homeRef = useRef(null);

    useEffect(() => {
        // تحسين IntersectionObserver
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        requestAnimationFrame(() => {
                            entry.target.classList.add('animate-in');
                            observer.unobserve(entry.target);
                        });
                    }
                });
            },
            {
                threshold: 0.1,
                rootMargin: '0px 0px -100px 0px'
            }
        );

        const elements = [
            document.querySelector('.know-more'),
            ...document.querySelectorAll('.about-us > div'),
            document.querySelector('.our-services h1'),
            document.querySelector('.our-services p'),
            document.querySelector('.services-cat'),
            document.querySelector('.seen-ourServices-h h1'),
            ...document.querySelectorAll('.seen-ourServices-b > div'),
            document.querySelector('.happyFYSuc')
        ].filter(el => el !== null);

        elements.forEach((el) => {
            observer.observe(el);
        });

        return () => {
            elements.forEach((el) => {
                if (el) observer.unobserve(el);
            });
        };
    }, []);

    return (
        <>
            <Header />
            <main ref={homeRef}>
                <div className="know-more">
                    <span>اعرف اكثر</span>
                </div>

                <div className="about-us">
                    <div>
                        <div className="about-h">
                            <div>
                                <img loading='lazy' src={ourLooking} alt="ourLooking" />
                            </div>
                            <h1>رؤيتنا</h1>
                        </div>
                        <p>
                            ان نصبح الشريك الإستراتيجي الأمثل والمفضل للشركات
                            <br />
                            والمؤسسات الطامحة في المملكة. من خلال تقديم خدمات
                            <br />
                            إدارية متكاملة تعزز من قدرتها التنافسية والتوسعية داخل
                            <br />
                            السوق السعودي. نحن نعتمد على فريق عمل ذو خبرة عالية
                            <br />
                            ومتميزة في هذا المجال لتحقيق هذا الهدف
                        </p>
                    </div>
                    <div>
                        <div className="about-h">
                            <div>
                                <img loading='lazy' src={ourMessage} alt="ourMessage" />
                            </div>
                            <h1>رسالتنا</h1>
                        </div>
                        <p>
                            نلتزم بتقديم خدمات مالية وقانونية وإدارية متكاملة تلبي احتياج
                            <br />
                            الشركات والمؤسسات بكفاءة عالية. نسعى لتحقيق
                            <br />
                            النجاح المشترك مع عملائنا من خلال الاهتمام بالتفاصيل،
                            <br />
                            الابتكار، والمهنية في كل ما نقدمة معتمدين على فريق من
                            <br />
                            المختصين ذوي الخبرة العالية في كل مجال.
                        </p>
                    </div>
                    <div>
                        <div className="about-h">
                            <div>
                                <img loading='lazy' src={ourValues} alt="ourValues" />
                            </div>
                            <h1>قيمنا</h1>
                        </div>
                        <p>
                            المصداقية والشفافية
                            <br />
                            المرونة والابتكار النمو مع موازنة الحياة
                        </p>
                    </div>
                </div>

                <div className="our-services" id='ourServices'>
                    <h1>خدماتنا</h1>
                    <p>نقدم لكم خدمات مميزة ستنال ارضائكم</p>
                    <div className="services-cat cate">
                        <div className={Active.allServices ? 'services-cat-activ' : ''}>
                            <Link to='/home/all' className={Active.allServices ? 'services-cat-b-activ' : ''}>الكل</Link>
                        </div>
                        <div className={Active.companyCreated ? 'services-cat-activ' : ''}>
                            <Link to='/home/companycreated' className={Active.companyCreated ? 'services-cat-b-activ' : ''}>تأسيس الشركات</Link>
                        </div>
                        <div className={Active.supportServices ? 'services-cat-activ' : ''}>
                            <Link className={Active.supportServices ? 'services-cat-b-activ' : ''} to='/home/supportservices'>الخدمات المساندة</Link>
                        </div>
                        <div className={Active.premiumResidency ? 'services-cat-activ' : ''}>
                            <Link className={Active.premiumResidency ? 'services-cat-b-activ' : ''} to="/home/premiumresidency">الإقامة المميزة</Link>
                        </div>
                        <div className={Active.marketingServices ? 'services-cat-activ' : ''}>
                            <Link className={Active.marketingServices ? 'services-cat-b-activ' : ''} to='/home/marketingservices'>خدمات التسويق</Link>
                        </div>
                        <div className={Active.accountingServices ? 'services-cat-activ' : ''}>
                            <Link className={Active.accountingServices ? 'services-cat-b-activ' : ''} to='/home/accountingservices'>الخدمات المحاسبة</Link>
                        </div>
                        <div className={Active.programming ? 'services-cat-activ' : ''}>
                            <Link className={Active.programming ? 'services-cat-b-activ' : ''} to='/home/programming'> خدمات البرمجة</Link>
                        </div>
                        <div className={Active.intellectualProperty ? 'services-cat-activ' : ''}>
                            <Link className={Active.intellectualProperty ? 'services-cat-b-activ' : ''} to='/home/intellpropservices'> خدمات الهيئة الملكية الفكرية</Link>
                        </div>
                    </div>
                    <div>

                    </div>
                    <Outlet />
                </div>

                <div className='seen-ourServices' ref={ref}>
                    <div className='seen-ourServices-h'>
                        <h1>إحصائيات</h1>
                    </div>
                    <div className="seen-ourServices-c">
                        <div className='seen-ourServices-b'>
                            <div className='year-of-exp'>
                                <img loading='lazy' src={yearOfExp} alt="year of experince" />
                                <h1>
                                    {inView ? <SafeCountUp end={data.year} duration={3} /> : 0}
                                </h1>
                                سنوات من الخبرة
                            </div>
                            <div className='infoComCre'>
                                <img loading='lazy' src={infoComCre} alt="year of experince" />
                                <h1>
                                    {inView ? <SafeCountUp end={data.companyCreated} duration={3} /> : 0}
                                </h1>
                                شركات تم تاسيسها
                            </div>
                            <div className='customer-satisfaction'>
                                <img loading='lazy' src={CustomerSatisfaction} alt="year of customer-satisfaction" />
                                <h1>
                                    {inView ? <SafeCountUp end={data.customerSatisfaction} duration={3} suffix="%" /> : '0%'}
                                </h1>
                                إرضاء العملاء
                            </div>
                            <div className='imployee-inSer'>
                                <img loading='lazy' src={ImployeeInSer} alt="ImployeeInSer" />
                                <h1>
                                    {inView ? <SafeCountUp end={data.employees} duration={3} /> : 0}
                                </h1>
                                موضف في خدمتك
                            </div>
                        </div>
                    </div>
                </div>

                <div className="happyFYSuc">
                    <h1>يسعدنا ان نكون جزءاً من نجاحك</h1>
                    <a href="tel:+0547382666">تواصل معنا</a>
                </div>
            </main>
        </>
    )
}

export default Home;